import { CompositeLensType, CompositeLensProduct, CompositeLensVariationType } from "constants/dataTypes";

export const getAvailibility = (availibility: any, lensMainProduct: CompositeLensType, haveUsCallOptometrist: any, prescriptionEmail: boolean) => {
    const availibilityLenses = ['single-vision-lenses', 'multifocal-lenses', 'bifocal-lenses'];
    if (availibility && Object.keys(availibility).length > 0 && !haveUsCallOptometrist && !prescriptionEmail) {
        lensMainProduct.products.map((lensProduct: CompositeLensProduct) => {
            if (availibilityLenses.includes(lensProduct.slug)) {
                lensProduct.variations.map((variation: CompositeLensVariationType) => {
                    if (variation.meta.attribute_pa_lens_thickness &&
                        variation.meta.attribute_pa_lens_thickness in availibility &&
                        (variation.meta.attribute_pa_treatment.replace('mirror-tint', 'mirror') in availibility[variation.meta.attribute_pa_lens_thickness] ||
                            variation.meta.attribute_pa_treatment in availibility[variation.meta.attribute_pa_lens_thickness]) &&
                        ((availibility[variation.meta.attribute_pa_lens_thickness][variation.meta.attribute_pa_treatment.replace('mirror-tint', 'mirror')] == variation.meta.attribute_pa_stock_type ||
                            availibility[variation.meta.attribute_pa_lens_thickness][variation.meta.attribute_pa_treatment] == variation.meta.attribute_pa_stock_type)
                            || (availibility[variation.meta.attribute_pa_lens_thickness][variation.meta.attribute_pa_treatment.replace('mirror-tint', 'mirror')] == 'multifocal' ||
                                availibility[variation.meta.attribute_pa_lens_thickness][variation.meta.attribute_pa_treatment] == 'multifocal' ||
                                availibility[variation.meta.attribute_pa_lens_thickness][variation.meta.attribute_pa_treatment.replace('mirror-tint', 'mirror')] == 'bifocal' ||
                                availibility[variation.meta.attribute_pa_lens_thickness][variation.meta.attribute_pa_treatment] == 'bifocal'))
                    ) {
                        variation.isAvailable = true;
                    } else {
                        variation.isAvailable = false;
                    }
                });
            }
        });

        return lensMainProduct.products;
    }

    if (prescriptionEmail || haveUsCallOptometrist) {
        lensMainProduct.products.map((lensProduct: CompositeLensProduct) => {
            lensProduct.variations.map((variation: CompositeLensVariationType) => {
                variation.isAvailable = true;
            });
        });

        return lensMainProduct.products;
    }

    lensMainProduct.products.map((lensProduct: CompositeLensProduct) => {
        lensProduct.variations.map((variation: CompositeLensVariationType) => {
            if (availibilityLenses.includes(lensProduct.slug)) {
                variation.isAvailable = false;
            } else {
                variation.isAvailable = false;
            }
        });
    });

    return lensMainProduct.products;
}